import { Pipe, PipeTransform } from '@angular/core';
import { ExamGroupPublicationStatus } from '../../models/enums/publication-status.enums';
import { ExamGroup } from '../../models/entities/exam-group.entity';

@Pipe({
  name: 'examGroupPublicationStatus',
})
export class ExamGroupPublicationStatusPipe implements PipeTransform {
  transform(publicationStatus: ExamGroupPublicationStatus, examGroup?: ExamGroup): string {
    switch (publicationStatus) {
      case ExamGroupPublicationStatus.DRAFT:
        return $localize`Brouillon`;
      case ExamGroupPublicationStatus.READY_FOR_PUBLICATION:
        return $localize`Prêt`;
      case ExamGroupPublicationStatus.PUBLISHED:
        if (examGroup && (examGroup.publishAt > new Date() || !examGroup.publishAt))
          return $localize`En attente`;
        else return $localize`Publié`;
      default:
        return '';
    }
  }
}
